import { memo } from 'react';
import { styled } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';

const SkeletonRow = styled(Skeleton)({
  height: 100,
  width: 'min(100%, 200px)',
  transform: 'none',
  borderRadius: '20px',
});

const GridSkeleton = ({ itemSx }) => {
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '24px 22px', justifyContent: 'center' }}>
      <SkeletonRow color='primary' sx={itemSx} />
      <SkeletonRow color='primary' sx={itemSx} />
    </Box>
  )
}

export default memo(GridSkeleton);